import { render, staticRenderFns } from "./PayTail.vue?vue&type=template&id=55243a3a&scoped=true"
import script from "./PayTail.vue?vue&type=script&lang=js"
export * from "./PayTail.vue?vue&type=script&lang=js"
import style0 from "./PayTail.vue?vue&type=style&index=0&id=55243a3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55243a3a",
  null
  
)

export default component.exports